import { render } from "./AnswerStep.vue?vue&type=template&id=411942f3&scoped=true"
import script from "./AnswerStep.vue?vue&type=script&lang=js"
export * from "./AnswerStep.vue?vue&type=script&lang=js"

import "./AnswerStep.vue?vue&type=style&index=0&id=411942f3&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/doineedavpn.com/doineedavpn.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-411942f3"]])

export default __exports__